function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  transform: "scale(.97183 1.0274) rotate(-45 11.311 2.6)",
  stroke: "#FAFAFA",
  d: "M0-.5h11.012"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  transform: "scale(-.97183 1.0274) rotate(-45 6.166 15.021)",
  stroke: "#FAFAFA",
  d: "M0-.5h11.012"
});

function SvgCloseinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgCloseinline;